const e = e => !(!e || "object" != typeof e || "boolean" != typeof e.disabled) && e.disabled;

export { e as default };
//# sourceMappingURL=index.js.map
